import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

export default function AuthLayout({ children }) {
  return (
    <div className="grid min-h-screen grid-cols-1 lg:grid-cols-2">
      <div className="flex flex-col justify-center px-6 py-12 sm:px-12 lg:px-20">
        <Link to="/" data-testid="auth-back-home" className="mb-8 inline-flex w-fit items-center gap-2 text-sm font-medium text-slate-600 transition hover:text-slate-950">
          <ArrowLeft className="h-4 w-4" /> Back to home
        </Link>
        <Link to="/" className="mb-10 block w-fit" aria-label="CleanIQ home">
          <img src="/cleaniq-logo.webp" alt="CleanIQ — Clean Data. Smarter CRM." className="h-auto w-52" />
        </Link>
        <div className="w-full max-w-sm">{children}</div>
        <p className="mt-10 max-w-sm font-mono text-[11px] leading-relaxed text-slate-400">
          CleanIQ connects securely to your CRM, scans data quality read-only, and only writes changes you approve. Your CRM remains the system of record.
        </p>
        <div className="mt-5 flex max-w-sm flex-wrap gap-x-4 gap-y-2 text-xs text-slate-500">
          <Link to="/terms" className="hover:text-slate-900">Terms</Link>
          <Link to="/privacy" className="hover:text-slate-900">Privacy</Link>
          <Link to="/refunds" className="hover:text-slate-900">Refunds</Link>
          <Link to="/trust" className="hover:text-slate-900">Trust Center</Link>
          <Link to="/security-overview" className="hover:text-slate-900">Security</Link>
          <Link to="/contact" className="hover:text-slate-900">Contact</Link>
        </div>
      </div>
      <div className="relative hidden lg:block">
        <img
          src="/cleaniq-og-data-flow.jpg"
          alt=""
          width="1200"
          height="630"
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-slate-900/70" />
        <div className="absolute bottom-0 left-0 p-12">
          <div className="font-mono text-xs uppercase tracking-[0.25em] text-white/60">Data Quality Engine</div>
          <h2 className="mt-3 max-w-md font-heading text-3xl font-bold leading-tight text-white">
            Clean, complete, trustworthy CRM data — on your terms.
          </h2>
        </div>
      </div>
    </div>
  );
}
